import { defineSlotRecipe } from "@chakra-ui/react";

const nativeSelectRecipe = defineSlotRecipe({
    className: "chakra-native-select",
    slots: ["root", "field", "indicator"],
    base: {
        root: {},
        field: {
            focusRingColor: "paleBlue.500",
            _focusVisible: {
                borderWidth: "1.5px",
                borderStyle: "solid",
                borderColor: "paleBlue.600",
                boxShadow: "0 0 0 1px",
                boxShadowColor: "paleBlue.600"
            }
        },
        indicator: {}
    },

    variants: {
        variant: {}
    }
});

export default nativeSelectRecipe;
